// common configuration
const config = {
    api: {
        baseUrl: "https://mailer.digitalwish.cz/api"
    },
    afterLoginRoute: "dashboard",
    vueAppUrl: "https://mailer.digitalwish.cz"
};

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    config["vueAppUrl"] = "http://localhost:9000";
    config["api"]["baseUrl"] = "http://localhost:9001";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_michal") {
    config["vueAppUrl"] = "http://localhost:35001";
    config["api"]["baseUrl"] = "http://localhost:35000";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_tomas") {
    config["vueAppUrl"] = "http://localhost:36005";
    config["api"]["baseUrl"] = "http://localhost:36004";
}

export const CONFIG = config;